import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getLocations, selectLocation } from "../Redux/Action/auth.action";
import logo from "../assets/pos-logo.svg";
import { useNavigate } from "react-router-dom";

const Locations = () => {
  const dispatch = useDispatch();
  const { authUser, locations } = useSelector((state) => state?.authReducer);
  const [specificLocations, setSpecificLocations] = useState([]);
  const token = localStorage.getItem("token");
  const navigate = useNavigate();
  useEffect(() => {
    if (authUser?.pos_location) {
      setSpecificLocations(authUser?.pos_location);
    }
  }, [authUser]);
  useEffect(() => {
    if (!token) {
      navigate("/");
    } else {
      dispatch(getLocations());
    }
  }, [token]);
  const dataLocation = locations?.filter((data) => specificLocations?.some((pos) => pos === data?._id));
  return (
    <>
      <div className="flex bg h-screen w-screen items-center justify-center">
        <div style={{ boxShadow: "0 20px 45px 0 rgba(3, 3, 3, 0.2)" }} className="w-full form sm:w-8/12 xl:w-1/3 my-5 mx-5 bg-white p-5 sm:p-7 rounded-[6px]">
          <div className="mb-4 text-center">
            <img className="mx-auto h-6 sm:h-7 w-auto" src={logo} alt="Your Company" />
          </div>
          <div className="flex items-center justify-between">
            <h6 className="font-medium text-gray-900">Select Location</h6>
          </div>
          <div className="w-full mt-6">
            <div>
              <ul className="mt-4 space-y-2">
                {dataLocation?.length > 0 ? (
                  dataLocation?.map((location, index) => (
                    <button key={index} className="hover:bg-[#F0F0F0] flex w-full text-left disabled:cursor-not-allowed disabled:hover:bg-white items-center justify-between duration-200 py-2 rounded-md cursor-pointer" onClick={() => dispatch(selectLocation({ location_id: location?._id }))}>
                      <div className="flex items-center">
                        <div className={`w-7 h-7 rounded-[6px] me-2 flex items-center font-medium capitalize justify-center bg-primary text-white`}>{location?.name?.charAt(0)}</div>
                        <div className="">{location?.name}</div>
                      </div>
                    </button>
                  ))
                ) : (
                  <div className="w-full table-text secondary-bg-color text-center border main-border-color mb-2.5 rounded-[6px] p-5">No Locations Found</div>
                )}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Locations;
